import axiosClient from "./axiosClient";

export const myPurchasesAPI = {
    getAssets: (params: any) => {
        const url = "assets/euro";
        return axiosClient.get(url, { params });
    },
    getMaintenancePlan: (params: any) => {
        const url = "maintenance-plans";
        return axiosClient.get(url, { params });
    },
    getBrandList: (params: any) => {
        const url = "assets/euro/brands";
        return axiosClient.get(url, { params });
    },
};
